import { CandyThunkAction } from "../Core/Store/CandyReduxTypes";
import { AbsoluteResolvedModelPath, emptyAbsoluteModelPath } from "../../../../Common/ModelPath/ModelPath";

export function highlightComponents(bindingPath: AbsoluteResolvedModelPath): CandyThunkAction {
    return (_, __, form) => {
        form.setHoveredPath(bindingPath);
    };
}

export function unhighlightComponents(): CandyThunkAction {
    return highlightComponents(emptyAbsoluteModelPath());
}
